var _line, _line2, _line3, _line4, _line5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 40,
    viewBox: "0 0 16 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.47265,
    y1: 10.7651,
    x2: 15.4726,
    y2: 0.765128,
    stroke: "#D4D4D8"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 0.47265,
    y1: 17.7651,
    x2: 15.4726,
    y2: 7.76513,
    stroke: "#D4D4D8"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 0.47265,
    y1: 24.7651,
    x2: 15.4726,
    y2: 14.7651,
    stroke: "#D4D4D8"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 0.47265,
    y1: 31.7651,
    x2: 15.4726,
    y2: 21.7651,
    stroke: "#D4D4D8"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 0.47265,
    y1: 38.7651,
    x2: 15.4726,
    y2: 28.7651,
    stroke: "#D4D4D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine);
export default __webpack_public_path__ + "static/media/line.68d4c9764abf6d072d30f38cbadc5595.svg";
export { ForwardRef as ReactComponent };